// Display/transport projection of existing Phase B offers; no identity matching.
export function entityOfferFromResponse(data) {
  const result = data.action?.result;
  const fields = result?.entity_resolution?.fields;
  if (!result?.requires_entity_confirmation || !Array.isArray(fields) || !fields.length
    || !data.conversation_id || !data.task_id || !Number.isInteger(data.task_version)
    || data.task_version < 1 || typeof data.task_hash !== "string" || data.task_hash.length !== 64) return null;
  const paths = new Set();
  const projected = [];
  for (const field of fields) {
    const type = field.result?.entity_type;
    const candidates = field.result?.candidates;
    if (typeof field.path !== "string" || paths.has(field.path)
      || !["customer", "product", "variant"].includes(type) || !Array.isArray(candidates)
      || candidates.some((candidate) => typeof candidate.public_id !== "string" || !candidate.public_id
        || typeof candidate.label !== "string" || !candidate.label)) return null;
    paths.add(field.path);
    projected.push({ path: field.path, type, candidates: candidates.map(({ public_id, label }) => ({ publicId: public_id, label })) });
  }
  return {
    conversationId: data.conversation_id, taskId: data.task_id,
    taskVersion: data.task_version, taskHash: data.task_hash, fields: projected,
  };
}

export function identitySelectionPayload(offer, selections) {
  if (!offer || Object.keys(selections).length !== offer.fields.length) return null;
  const selected = [];
  for (const field of offer.fields) {
    const publicId = selections[field.path];
    if (!field.candidates.some((candidate) => candidate.publicId === publicId)) return null;
    selected.push({ path: field.path, candidate_public_id: publicId });
  }
  // Feed exact offered IDs into the existing locked Phase B validation path.
  return { action: "select", selections: selected };
}
